import apiService from '@/services/apiService';

const actions = {
  getAboutUsBanner({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get('about-us-banner/find-one')
        .then((response) => {
          commit('getAboutUsBanner', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  postAboutUsBanner({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('about-us-banner/insert-or-update', payload)
        .then((response) => {
          // commit('postAboutUsBanner', payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },


};

export default actions;